import { render, staticRenderFns } from "./performance-flywheel.vue?vue&type=template&id=0315d814"
import script from "./performance-flywheel.vue?vue&type=script&lang=ts"
export * from "./performance-flywheel.vue?vue&type=script&lang=ts"
import style0 from "./performance-flywheel.vue?vue&type=style&index=0&id=0315d814&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports